import { useEffect, useState } from "react";
import  {getDerniersRendezVous}  from "../../api/rendezVousService.api";

export default function DerniersRendezVous() {
    const [data, setData] = useState([]);
      const [loading, setLoading] = useState(true);
  const formatDateFR = (dateSQL) => {
  if (!dateSQL) return "";
  const [y, m, d] = dateSQL.split("-");
  return `${d}/${m}/${y}`;
}; 
     useEffect(() => {
        loadData();
     }, []);
   const loadData = async () => {
       try {
         const res = await getDerniersRendezVous();
         setData(res.data);
         console.log(data);
         
       } catch (err) {
         console.error("Erreur chargement dashboard", err);
       } finally {
         setLoading(false);
       }
     };
   

  return (
    <div>
       <table className="responsive-table">
  <thead>
    <tr>
       
        <th>Date</th>
        <th>Type entretien</th>
        <th>Client</th>
        <th>Téléphone</th>
        <th>État</th>  
       
    </tr>
  </thead>
  <tbody>
    {data.map(r => (
      <tr key={r.id}>
        
        <td data-label="Date">{formatDateFR(r.date_rdv)}</td> 
        <td data-label="Type d'entretien">{r.type_entretien}</td>
        <td data-label="Client">{r.client}</td>
        <td data-label="Télèphone">
        <a
          href={`tel:${r.telephone}` } className="phone-link"
          onClick={(e) => {
            if (!window.confirm(`Appeler ${r.telephone} ?`)) {
              e.preventDefault();
            }
          }}
        >
           {r.telephone}
        </a></td>
        <td data-label="État">
          <span className={`badge ${r.etat_travaux}`} >
            {r.etat_travaux}
          </span>
        </td>
      </tr>
    ))}
  </tbody>
</table>
</div>
  )
}
